import React from "react";
import PropTypes from "prop-types";
//
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { styled, withStyles } from "@material-ui/styles";

//
const StyledTableCell = withStyles(() => ({
  head: {
    // backgroundColor: 'rgba(87, 61, 26, 1)',
    // backgroundColor: 'rgba(171, 128, 72, 1)',
    // color: '#fff',
    // color: 'rgba(87, 61, 26, 0.95)',
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledSpan = styled("span")(({ theme }) => ({
  border: 0,
  clip: "rect(0 0 0 0)",
  height: 1,
  margin: -1,
  overflow: "hidden",
  padding: 0,
  position: "absolute",
  top: 20,
  width: 1,
}));

function EnhancedTableHead(props) {
  // eslint-disable-next-line no-unused-vars
  const { order, orderBy, onRequestSort, headCells } = props;
  //
  //
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <StyledTableCell
            key={headCell.id}
            align="center"
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              <Box fontSize="1rem">
                <Typography noWrap variant="inherit">
                  {headCell.label}
                </Typography>
              </Box>

              {orderBy === headCell.id ? (
                <StyledSpan>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </StyledSpan>
              ) : null}
            </TableSortLabel>
          </StyledTableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  // eslint-disable-next-line react/require-default-props
  headCells: PropTypes.arrayOf(PropTypes.object),
};

export default EnhancedTableHead;
